import ApiService from '@/helpers/api.service';
import ApiService2 from "@/helpers/api.service.ext";
const API = new ApiService();
const API2 = new ApiService2();
const REPORT_ENDPOINT = '/report';

export const state = { errors: null }
export const mutations = {
  SET_EXPORT_ERROR(state, errors){
    state.errors = errors;
  },
}

export const actions = {
  exportReport(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${REPORT_ENDPOINT}/export`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch((response) => {
          context.commit('SET_EXPORT_ERROR', response.data.errors);
          reject();
        });
    });
  },
  exportReportExt(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${REPORT_ENDPOINT}/export`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch((response) => {
          context.commit('SET_EXPORT_ERROR', response.data.errors);
          reject();
        });
    });
  },
  exportReportXLSL(context, params){
    return new Promise((resolve, reject) => {
      API2.post(`${REPORT_ENDPOINT}/export-xlsx`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve(data);
          }
        })
        .catch((response) => {
          context.commit('SET_EXPORT_ERROR', response.data.errors);
          reject();
        });
    });
  },
  exportReportExtBatch(context, params){
    return new Promise((resolve, reject) => {
      //export-batch
      API2.post(`${REPORT_ENDPOINT}/invoke-export`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch((response) => {
          context.commit('SET_EXPORT_ERROR', response.data.errors);
          reject();
        });
    });
  },
}

export const getters = {}